import React from 'react';

import { ListingPageFilterBar } from '@futrli/ui-components/components/listing-page/listing-page-filter-bar/listing-page-filter-bar';

import { ForecastTypeFilterValues } from '../../types';
import { SortByFilter } from './components/sort-by-filter';
import { StatusFilter } from './components/status-filter';
import { TypeShownFilter } from './components/type-shown-filter';

interface MyForecastsFilterBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  statusFilterValue: string;
  onStatusFilterChange: (value: string) => void;
  typeShownFilterValue: ForecastTypeFilterValues;
  onTypeShownFilterChange: (value: string) => void;
  sortByFilterValue: string;
  onSortByFilterChange: (value: string) => void;
  stickyTop?: number;
  isResourceSharingEnabled?: boolean;
}

export const MyForecastsFilterBar = ({
  searchTerm,
  onSearchChange,
  statusFilterValue,
  onStatusFilterChange,
  typeShownFilterValue,
  onTypeShownFilterChange,
  sortByFilterValue,
  onSortByFilterChange,
  stickyTop,
  isResourceSharingEnabled = false
}: MyForecastsFilterBarProps) => {
  return (
    <ListingPageFilterBar
      searchTerm={searchTerm}
      onSearchChange={onSearchChange}
      rightContent={<SortByFilter onChange={onSortByFilterChange} selectedValue={sortByFilterValue} />}
      stickyTop={stickyTop}
    >
      <>
        <StatusFilter
          onChange={onStatusFilterChange}
          selectedValue={statusFilterValue}
          isResourceSharingEnabled={isResourceSharingEnabled}
        />
        <TypeShownFilter onChange={onTypeShownFilterChange} selectedValue={typeShownFilterValue} />
      </>
    </ListingPageFilterBar>
  );
};
